const timeoutModal = (payload) => {
  return {
    type: "timeoutmodal",
    payload,
  };
};

export default timeoutModal;
